import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Logo from "../assets/images/logo/Orgeven logo 1.svg";
import SmallLogo from "../assets/images/logo/Orgeven-icon--logo.svg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ReviewModal from "../components/ReviewModel";
import FeedbackModel from "../components/FeedbackModel";
import { useSelector } from "react-redux";
import { getImage } from "../utils/utils";

function Navbar({eventAdmin}) {
  const [anchorElUser, setAnchorElUser] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const { userData } = useSelector((state) => state?.profileData);

  const navigate = useNavigate();
  const location = useLocation();
  const isEvent = location.pathname === "/event";

  const toggleReviewModal = () => {
    setOpenModal(!openModal);
  };

  const toggleFeedbackModal = () => {
    setOpenFeedbackModal(!openFeedbackModal);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("userData");
    window.location.href = "/login";
  };

  return (
    <Container maxWidth="lg">
      <AppBar
        position="static"
        elevation={3}
        sx={{
          px: 2,
          borderBottomLeftRadius: isEvent ? 0 : 20,
          borderBottomRightRadius: isEvent ? 0 : 20,
        }}
      >
        <Toolbar disableGutters>
          <Box
            component="img"
            sx={{
              display: { xs: "none", md: "flex" },
              mr: 4,
              height:'50px',
              maxWidth:'180px',
              cursor: "pointer",
            }}
            alt="Logo"
            onClick={() => navigate("/dashboard")}
            src={eventAdmin?.picture ? getImage('event-admin', eventAdmin?.picture) : Logo}
          />

          <Box
            component="img"
            sx={{
              width: 40,
              display: { xs: "flex", md: "none" },
              mr: 4,
              maxWidth: { xs: 40, md: 40 },
              cursor: "pointer",
            }}
            alt="Logo"
            onClick={() => navigate("/dashboard")}
            src={SmallLogo}
          />

          <Typography
            variant="h7"
            sx={{ display: { xs: "none", md: "block", fontSize: 18 } }}
          >
            Welcome back,{" "}
            <Typography variant="span" color="primary">
              {userData?.name || ""}
            </Typography>
          </Typography>
          <Box sx={{ flexGrow: 0, ml: "auto" }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt={userData?.name}
                  src={getImage("guest", userData?.picture)}
                />
              </IconButton>
            </Tooltip>
            <Menu
              PaperProps={{
                sx: { width: 300, maxHeight: 500, borderRadius: 3 },
              }}
              MenuListProps={{
                // style the menu list
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                },
              }}
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt={userData?.name}
                  src={getImage("guest", userData?.picture)}
                  sx={{ width: 100, height: 100, fontSize: 40 }}
                />
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {userData?.name}
                </Typography>
              </Box>

              <MenuItem
                onClick={() => {
                  handleCloseUserMenu();
                  navigate("/profile");
                }}
              >
                <Typography textAlign="center">My Profile</Typography>
              </MenuItem>
              {/* <MenuItem onClick={handleCloseUserMenu}>
                <Typography
                  textAlign="center"
                  onClick={() => toggleReviewModal()}
                >
                  Review to Application
                </Typography>
              </MenuItem> */}
              <MenuItem
                onClick={() => {
                  handleCloseUserMenu();
                  toggleFeedbackModal();
                }}
              >
                <Typography textAlign="center">Feedback / Suggestion</Typography>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleCloseUserMenu();
                  handleLogout();
                }}
              >
                <Typography textAlign="center" color={"danger.main"}>
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <ReviewModal
        open={openModal}
        toggle={toggleReviewModal}
        user_type={"system"}
        review_type="system"
        title="Review To Application"
      />
      <FeedbackModel open={openFeedbackModal} toggle={toggleFeedbackModal} />
    </Container>
  );
}
export default Navbar;
